module.exports = __webpack_public_path__ + "static/white-fudo-logo-80c5f65761fe0d174aa26026d0952376.svg";